import React from 'react'
import { ControlLabel } from '../../common/form-components/label/Label'
import FulesPriceTable from '../fuel-prices/FuelsPriceTable'
import LabeledDropdown from '../../common/form-components/labeled-dropdown/LabeledDropdown'
import LabeledCheckbox from '../../common/form-components/labeled-checkbox/LabeledCheckbox'
import { propsInputNumberCurrency } from '../../../utils/constants/common'
import LabeledPrice from '../../common/form-components/labeled-inputs/LabeledPrice'
import './fuelStationComparisionItem.scss'

const FuelStationComparisionItem = ({
  comparison,
  inputs,
  favoriteStations,
  onHandleChange,
  isOnlyInfo,
}) => {
  const owStationOptionTemplate = (option) =>
    option.label + ' - ' + option.addressInfo.address

  const selectedOwnStationTemplate = (option, props) => {
    if (option) {
      return option.label + ' - ' + option.addressInfo.address
    }
    return props.placeholder
  }

  return (
    <div className="comparision-content-item">
      <LabeledDropdown
        idLabel={comparison}
        name={`comparisons.${comparison}.favoriteStation`}
        value={inputs?.favoriteStation}
        valueTemplate={selectedOwnStationTemplate}
        options={favoriteStations}
        optionLabel="label"
        itemTemplate={owStationOptionTemplate}
        onChange={(e) => onHandleChange(e, comparison)}
        disabled={isOnlyInfo}
        showClear
      />
      <div className="flex-container">
        {inputs?.favoriteStation?.prices && (
          <div>
            <ControlLabel id="prices.reported.to.minetur" />
            <FulesPriceTable prices={[inputs?.favoriteStation]} />
          </div>
        )}
      </div>

      <LabeledPrice
        idLabel="difference"
        name={`comparisons.${comparison}.difference`}
        value={inputs?.difference}
        onChange={(e) => onHandleChange(e)}
        disabled={isOnlyInfo}
        {...propsInputNumberCurrency}
      />
      <LabeledCheckbox
        idLabel="active"
        name={`comparisons.${comparison}.enabled`}
        onChange={(e) => onHandleChange(e)}
        checked={inputs?.enabled}
        disabled={isOnlyInfo}
      />
    </div>
  )
}

export default FuelStationComparisionItem
